export const Location = {
    //allow us to stringify a location
    stringify: (lat, lng, address) => "geo:"+lat+","+lng+"?q="+address,
    //allow us to parse a location
    parse: (string) => {
        //default
        const error = {
            lat: 44.854165, 
            lng: -0.566282,
            address: "Bordeaux Ynov Campus, 89 Quai des Chartrons, 33300 Bordeaux, France"
        }

        //nothing
        if(!string) return error;
        //object return an object
        if(typeof string === "object") return string; 

        const query = string.split('?q=');
        //if a query is empty
        if(query.length === 0) return error;

        //search coordinates
        const coordinatesMatch = query[0].match(/-?(90|[0-8]?\d)(\.\d+)?,*-?(180|1[0-7]\d|\d?\d)(\.\d+)?$/g);

        if(!coordinatesMatch) return error;

        const coordinates = coordinatesMatch[0].split(',');

        return {
            lat: Number(coordinates[0]) || error.lat,
            lng: Number(coordinates[1]) || error.lng,
            address: query[1] || error.address
        }
    }
} 



// WEBPACK FOOTER //
// ./src/helper/map/Constants.js